module.exports = __webpack_public_path__ + "static/media/The_Core_Four_B.6df85feb.png";